import 'react-dates/initialize';

import React from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';

import 'react-dates/lib/css/_datepicker.css';
import './index.css';

import WidgetApp from 'WidgetApp';
import i18nWrapper from './i18n';

import * as serviceWorker from './serviceWorker';

import {
  WIDGET_BUTTON_ID,
  WIDGET_ACCOMMODATION_ID_ATTRIBUTE,
  WIDGET_ACTIVITY_ID_ATTRIBUTE,
  WIDGET_OWNER_ID_ATTRIBUTE,
  WIDGET_COLOR_ATTRIBUTE,
  WIDGET_GOOGLE_ANALYTICS_ID_ATTRIBUTE,
  WIDGET_LANGUAGES_ATTRIBUTE,
  WIDGET_LOGO_ATTRIBUTE,
  WIDGET_ROOT,
  WIDGET_PRIVACY_POLICY_ATTRIBUTE,
  WIDGET_TERMS_AND_CONDITIONS_ATTRIBUTE,
  WIDGET_WRAPPER_ID
} from 'constants/widget';

const mountApp = btn => {
  const iframe = window.parent.document.getElementById(WIDGET_WRAPPER_ID);
  iframe.style.display = 'block';

  if (btn) {
    btn = btn.currentTarget;
  }

  // const btn = window.parent.document.getElementById(WIDGET_BUTTON_ID);
  const ownerId = btn && btn.getAttribute(WIDGET_OWNER_ID_ATTRIBUTE);
  const accommodationId =
    btn && btn.getAttribute(WIDGET_ACCOMMODATION_ID_ATTRIBUTE);
  const activityId = btn && btn.getAttribute(WIDGET_ACTIVITY_ID_ATTRIBUTE);
  const color = btn && btn.getAttribute(WIDGET_COLOR_ATTRIBUTE);
  const googleAnalyticsTracking =
    btn && btn.getAttribute(WIDGET_GOOGLE_ANALYTICS_ID_ATTRIBUTE);
  const languages = btn && btn.getAttribute(WIDGET_LANGUAGES_ATTRIBUTE);
  const logo = btn && btn.getAttribute(WIDGET_LOGO_ATTRIBUTE);
  const privacyPolicy =
    btn && btn.getAttribute(WIDGET_PRIVACY_POLICY_ATTRIBUTE);
  const termsAndConditions =
    btn && btn.getAttribute(WIDGET_TERMS_AND_CONDITIONS_ATTRIBUTE);

  let listOfLanguages = [];

  if (languages && languages.length) {
    listOfLanguages = languages.split(',');
  } else {
    listOfLanguages = ['English'];
  }

  listOfLanguages = listOfLanguages.map(item => {
    if (item === 'Norwegian') {
      return 'Norway';
    }
    return item;
  });

  ReactDOM.render(
    <I18nextProvider i18n={i18nWrapper(listOfLanguages[0])}>
      <WidgetApp
        ownerId={ownerId}
        receivedAccommodationId={accommodationId}
        receivedActivityId={activityId}
        color={color}
        logo={logo}
        googleAnalyticsTracking={googleAnalyticsTracking}
        languages={listOfLanguages}
        privacyPolicy={privacyPolicy}
        termsAndConditions={termsAndConditions}
      />
    </I18nextProvider>,
    document.getElementById(WIDGET_ROOT)
  );
};

window.mountApp = mountApp;

// mountApp();

/*let addEventListenerToMountApp = setInterval(function() {
  const button = window.parent.document.getElementById(WIDGET_BUTTON_ID);

  if (button) {
    clearInterval(addEventListenerToMountApp);
    button.addEventListener('click', mountApp);
  }
}, 100);*/

// For local test
// ReactDOM.render(
//   <I18nextProvider i18n={i18nWrapper('English')}>
//     <WidgetApp
//       ownerId={"23"}
//       // receivedActivityId={"834"}
//       // receivedAccommodationId={369}
//       // ownerId={"65"} - prod owner
//       // receivedActivityId={"114"} - prod act
//       logo="https://hornmediafiles.s3.amazonaws.com/media/widget/clark-tibbs-oqStl2L5oxI-unsplash_uXPkKVD.jpg"
//       color="#87BEA4"
//       languages={['English', 'Norway']}
//     />
//   </I18nextProvider>,
//   document.getElementById('root')
// );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
